import { Vue, Component, Watch } from "vue-property-decorator";
import DynComponent from '@/components/dyn-component';
import { State, Action } from 'vuex-class';
import { arrDiff } from "@/lib/helpers";
import PanelConfirm from '../panel-confirm';
import { VNode } from 'vue';

@Component
export default class DynPanel extends Vue {

  @State(s => s.dynPanel.dynPanelStack) stack: {uid: string; clazz: Function, props: any, on: any}[];

  protected displayedStack: {uid: string; clazz: Function, props: any, on: any}[] = [];

  created() {
    this.onStackChange(this.displayedStack, []);
  }

  onPanelCommit(emitter, args) {
    if (emitter.on.commit) {
      emitter.on.commit({emitter, ...args});
    }
  }

  onPanelCancel(emitter, args) {
    if (emitter.on.cancel) {
      emitter.on.cancel({emitter, ...args});
    }
  }

  @Watch('stack')
  async onStackChange(next, prev) {
    if (next) {
      let { removed } = arrDiff(prev || [], next, v => v.uid);
      await Promise.all(removed.map(this.closePanel));
      this.displayedStack = [...this.stack];
    }
  }
  
  async closePanel({uid}) {
    const comp = this.$refs[uid];
    await (comp as DynComponent).forward("hide");
  }

  render() {
    return (
      <div>
        {this.displayedStack.map(
          emitter => <DynComponent
            key={emitter.uid}
            ref={emitter.uid}
            clazz={emitter.clazz}
            propz={emitter.props}
            onCancel={opts => this.onPanelCancel(emitter, opts)}
            onCommit={opts => this.onPanelCommit(emitter, opts)}/>
          )
        }
      </div>
    );
  }

}

@Component
class DynPanelAware extends Vue {

  @Action pushPanel;
  @Action popPanel;

  promiseConfirmPanel(message: string | VNode): Promise<boolean> {
    return new Promise(res => this.pushPanel({
      clazz: PanelConfirm,
      props: {
        message,
        confirmButtonLabel: "Oui"
      },
      on: {
        commit: ({emitter}) => {
          res(true);
          emitter.remove();
        },
        cancel: ({emitter}) => {
          res(false);
          emitter.remove();
        }
      }
    }));
  }

  created() {}

}

export { DynPanelAware };
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-4a5115f6/index.tsx" });